// IDs used as translation keys for meta title and description
export enum PageId {
    HOMEPAGE = 'homepage',
    APP_DEVELOPMENT = 'appDevelopment',
    CAMPAIGN = 'campaign',
    ABOUT_US = 'aboutUs',
    DESIGN = 'design',
    CAREER = 'career',
    PRAGUE = 'prague',
    BERLIN = 'berlin',
    CONTACT = 'contact',
    REFERENCES = 'references',
    WORKSHOP = 'workshop',
    NOT_FOUND = 'notFound',
    REFERENCES_ARCHIVE = 'archive',
    CHRISTMAS_PROMOTION = 'christmasPromotion',
    COOKIES = 'cookies',
    BLOG = 'blog',
}
